export default "__VITE_ASSET__5d72a53a__"